import TransectCreate from './TransectCreate';
import TransectEdit from './TransectEdit';
import TransectList from './TransectList';
import TransectShow from './TransectShow';
import TimelineIcon from '@mui/icons-material/Timeline';

const Transect = {
    create: TransectCreate,
    edit: TransectEdit,
    list: TransectList,
    show: TransectShow,
    recordRepresentation: 'name',
    icon: TimelineIcon,
};



export default Transect;